import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import './styles.css';

const TableScroll = ({children, className = '', style = {}, stickyActions = false, cellHover = false, onScroll}) => {
    const containerRef = useRef(null);
    const [hasHorizontalOverflow, setHasHorizontalOverflow] = useState(false);

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return undefined;

        const updateOverflow = () => {
            setHasHorizontalOverflow(container.scrollWidth > container.clientWidth);
        };

        updateOverflow();

        if (typeof ResizeObserver !== 'undefined') {
            const observer = new ResizeObserver(updateOverflow);
            observer.observe(container);
            if (container.firstElementChild) observer.observe(container.firstElementChild);
            return () => observer.disconnect();
        }

        window.addEventListener('resize', updateOverflow);
        return () => window.removeEventListener('resize', updateOverflow);
    }, [children]);

    return (
        <div
            ref={containerRef}
            className={`table-scroll ${stickyActions ? 'table-scroll--sticky-actions' : ''} ${cellHover ? 'table-scroll--cell-hover' : ''} ${hasHorizontalOverflow ? 'has-horizontal-overflow' : ''} ${className}`}
            style={style}
            onScroll={onScroll}
        >
            {children}
        </div>
    );
};

TableScroll.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    style: PropTypes.object,
    stickyActions: PropTypes.bool,
    cellHover: PropTypes.bool,
    onScroll: PropTypes.func,
};

export default TableScroll;



// WEBPACK FOOTER //
// ./src/components-new/table/TableScroll/index.jsx